import React, { useState } from 'react';
import style from './style';
import EAIcon from 'components/common/EAIcon';
import clsx from 'clsx';
import { Collapse } from '@mui/material';
import i18next from 'i18next';
import EAButton from 'components/common/EAButton';
import EAColorIcon from '../../../../../../../components/common/EAColorIcon';

const AttributsList = ({
  title,
  titleExample,
  attributs = [],
  onCreateAttribute,
  removeAttribute,
  onEdit,
}) => {
  const { classes } = style();
  const [isOpen, setIsOpen] = useState(!attributs.length);

  return (
    <div className={classes.root}>
      <div className={classes.header} onClick={() => setIsOpen(!isOpen)}>
        <h2 className={classes.title}>{title}</h2>
        <span className={classes.example}>{titleExample}</span>
        <EAIcon
          onClick={() => setIsOpen(!isOpen)}
          icon={'arrow/arrow-collapsible'}
          className={clsx(classes.collapsibleIcon, !isOpen ? 'closed' : '')}
        />
      </div>
      <Collapse in={isOpen} timeout="auto">
        <div className={classes.contentContainer}>
          {attributs.length ? (
            <div>
              <div className={classes.content}>
                {attributs.map((att, i) => {
                  return (
                    <>
                      {att.label ? (
                        <div className={classes.attributWrapper}>
                          <div
                            className={classes.attributInfos}
                            onClick={() => onEdit(att)}
                          >
                            <div className={classes.attributLibelle}>
                              {att.label}
                            </div>
                            <div className={classes.attributType}>
                              {i18next.t(`attributeType.${att.type}`)}
                            </div>
                          </div>
                          <EAIcon
                            className={classes.deleteAttributButton}
                            icon={'delete_red'}
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              removeAttribute(i);
                            }}
                          />
                        </div>
                      ) : (
                        ''
                      )}
                    </>
                  );
                })}
              </div>
              <EAButton
                className={classes.addAttribute}
                icon={'add'}
                onClick={(e) => {
                  e.preventDefault();
                  onCreateAttribute();
                }}
                content={i18next.t(
                  'demandes.contextModel.creationForm.attributs.ajouterAttribut'
                )}
              />
            </div>
          ) : (
            <div
              onClick={() => onCreateAttribute()}
              className={classes.emptyContent}
            >
              <EAColorIcon icon={'add'} />
              <div className={classes.emptyContentTitle}>
                {i18next.t(
                  'demandes.contextModel.creationForm.attributs.ajouterAttributs'
                )}
              </div>
            </div>
          )}
        </div>
      </Collapse>
    </div>
  );
};

export default AttributsList;
